
<div class="alert alert-warning" *ngIf="IspartiallySuccess">
  <error-display [error]="error" [showPossibleResolution]="showPossibleResolution"></error-display>
</div>
<div class="alert alert-danger" *ngIf="showError">
  <error-display [error]="error" [showPossibleResolution]="showPossibleResolution" [guideLink]="guideLink"></error-display>
</div>